import { render, staticRenderFns } from "./CellItem.vue?vue&type=template&id=b6da2098&scoped=true&"
import script from "./CellItem.vue?vue&type=script&lang=js&"
export * from "./CellItem.vue?vue&type=script&lang=js&"
import style0 from "./CellItem.vue?vue&type=style&index=0&id=b6da2098&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6da2098",
  null
  
)

export default component.exports